import React from "react";
import "../assets/css/styles.css";
import { Discord, Instagram, Mail } from "../components/Icons";

const CHANNELS = [
  {
    icon: <Mail />,
    title: "Email",
    body: "Questions about an order, a campaign or partnering with us.",
    value: "info@farmerboaz.com",
    href: "mailto:info@farmerboaz.com",
  },
  {
    icon: <Instagram />,
    title: "Instagram",
    body: "Farm visits, harvest days and what is coming up next.",
    value: "@farmerboaz",
    href: "https://www.instagram.com/farmerboaz?igsh=MXNrdGMwbjdqcW5lNQ==",
  },
  {
    icon: <Discord />,
    title: "Discord",
    body: "Join the community for updates, transparency and group buys.",
    value: "Farmer Boaz community",
    href: "https://discord.gg/X47Vt45XWh",
  },
];

const Contact = () => {
  return (
    <section id="contact" className="section section--surface contact">
      <div className="container">
        <div className="section-head" data-reveal>
          <span className="eyebrow">Contact us</span>
          <h2>We would love to hear from you</h2>
          <p>
            Whether you have a question, feedback, or want to partner with us — pick whichever
            channel suits you best.
          </p>
        </div>

        <div className="contact-grid">
          {CHANNELS.map((channel, index) => (
            <a
              className="contact-card"
              key={channel.title}
              href={channel.href}
              target={channel.href.startsWith("mailto:") ? undefined : "_blank"}
              rel={channel.href.startsWith("mailto:") ? undefined : "noopener noreferrer"}
              data-reveal
              style={{ "--reveal-delay": `${index * 90}ms` }}
            >
              <span className="contact-card-icon">{channel.icon}</span>
              <h3>{channel.title}</h3>
              <p>{channel.body}</p>
              <span className="contact-value">{channel.value}</span>
            </a>
          ))}
        </div>

        <div className="contact-cta" data-reveal>
          <h3>Ready to taste the difference?</h3>
          <p>
            Join a community share today and get farm-fresh quality delivered straight to your
            door.
          </p>
          <a href="mailto:info@farmerboaz.com" className="btn btn--lg btn--light">
            Email us
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
